import React from "react";
import { Grid } from "@mui/material";
import { IoMdHome } from "react-icons/io";
import { FaBackward } from "react-icons/fa";
import { HiOutlineMenuAlt3 } from "react-icons/hi";
const Footer = () => {
  return (
    <Grid
      container
      className="py-2 rounded-top-4 shadow text-white"
      sx={{
        position: "fixed",
        bottom: "0",
        backgroundColor: "#000000ff",
        zIndex: "100",
      }}
    >
      <Grid item xs={4} className="text-center">
        <HiOutlineMenuAlt3 size={30} />
      </Grid>
      <Grid item xs={4} className="text-center">
        <IoMdHome size={30} />
      </Grid>
      <Grid item xs={4} className="text-center ">
        <FaBackward size={30} />
      </Grid>
    </Grid>
  );
};

export default Footer;
